<template>
  <div class="plans">
    <div class="plan" v-for="plan in filteredPlans" v-if="plans">
      <h2>
        {{ plan.name }}
        <span v-if="plan.min_users" class="min-users"
          >({{ $t("message.min-x-users", [plan.min_users]) }})</span
        >
      </h2>
      <div class="pricing" v-if="plan.monthly_price">
        <span>{{ capitalize($t("message.monthly")) }}</span>
        <span>
          <span class="original-price" v-if="plan.original_monthly"
            >${{ plan.original_monthly / 100 }}</span
          >
          ${{ plan.monthly_price / 100 }} / {{ $t("message.month") }} /
          {{ $t("message.learner") }}
          <template v-if="plan.original_monthly"
            >*</template
          >
        </span>
        <button
          v-if="isDisabled(plan.id, 'month')"
          :disabled="true"
          class="lp-btn lp-btn-primary"
        >
          {{ selectedText }}
        </button>
        <button
          v-if="requiresHelpDesk(plan)"
          class="lp-btn lp-btn-primary"
          @click="$store.commit('setPage', 'helpView')"
          @keyup.enter="$store.commit('setPage', 'helpView')"
        >
          {{ $t("message.contact-us") }}
        </button>
        <a
          v-if="!isDisabled(plan.id, 'month') && !requiresHelpDesk(plan)"
          class="lp-btn lp-btn-primary"
          href=""
          @click.prevent="updatePlan(plan, 'monthly')"
        >
          {{ $t("message.select-plan") }}
        </a>
      </div>
      <div class="pricing" v-if="plan.annual_price">
        <span>{{ $t("message.annual") }}</span>
        <span
          ><span class="original-price" v-if="plan.original_annual"
            >${{ plan.original_annual / 100 }}</span
          >${{ plan.annual_price / 100 }} / {{ $t("message.year") }} /
          {{ $t("message.license") }}
          <template v-if="plan.original_annual"
            >*</template
          ></span
        >
        <button
          v-if="isDisabled(plan.id, 'year')"
          :disabled="true"
          class="lp-btn lp-btn-primary"
        >
          {{ selectedText }}
        </button>
        <a
          v-else
          class="lp-btn lp-btn-primary"
          href=""
          @click.prevent="updatePlan(plan, 'annual')"
        >
          {{ $t("message.select-plan") }}
        </a>
      </div>
      <p v-for="feature in plan.features">{{ feature }}</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
.plans {
  display: flex;
  width: 850px;
  .plan {
    padding: 20px;
    box-sizing: border-box;
    font-family: "myriad-pro", Helvetica, Arial, sans-serif;
    h2 {
      font-weight: bold;

      .min-users {
        font-weight: normal;
        font-size: 0.9em;
        margin-left: 0.25em;
        display: inline-block;
        color: #333;
      }
    }
    &:nth-child(2) {
      background: #f2f2f2;
    }
    p {
      line-height: 125%;
      color: #000;
      padding-bottom: 22px;
    }
    .lp-btn {
      margin-top: 0px;
    }
    .original-price {
      text-decoration: line-through;
      color: #999;
      margin-right: 2px;
      display: inline-block;
    }
  }
  @media screen and (max-width: 850px) {
    width: 100%;
    display: block;
    .plan {
      width: 100%;
      display: block;
      .pricing {
      }
    }
  }
  @media screen and (max-width: 450px) {
    .plan {
      .pricing {
        display: block;
        span {
          display: block;
        }
        .lp-btn {
          margin-bottom: 12px;
        }
      }
    }
  }
}

.pricing {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  &:first-of-type {
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }
  &:last-of-type {
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
}

.lp-btn {
  width: 8.6em;
  margin-top: 5px;
  &:disabled {
    border-color: #777;
    background-color: #777;
  }
}
</style>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";

export default {
  computed: {
    ...mapState({
      plans: (state) => state.payment.plans,
      currentSubscription: (state) => state.payment.currentSubscription,
    }),
    ...mapGetters(["seats"]),
    filteredPlans() {
      return this.plans.filter((plan) => !plan["hidden_from_selection"]);
    },
    selectedText() {
      return this.currentSubscription && this.currentSubscription.renewal_plan
        ? this.$t("message.scheduled-plan")
        : this.$t("message.current-plan");
    },
  },
  mounted() {
    if (!this.plans) {
      this.getPlans();
    }
    if (this.currentSubscription) {
      this.$store.commit("setDiscount", this.currentSubscription.discount);
    }
  },
  methods: {
    updatePlan(plan, period) {
      if (this.currentSubscription && this.currentSubscription.seats < plan.min_users) {
        this.$store.commit("setPage", "invalidPlan");
      } else {
        this.$store.commit("setPlan", plan);
        this.$store.commit("setPricingPeriod", period);
        this.$store.commit("setShowPlans", false);
      }
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    requiresHelpDesk(plan) {
      if (this.currentSubscription) {
        return (
          this.currentSubscription.interval == "year" &&
          plan.sort_order > this.currentSubscription.plan.sort_order
        );
      }
    },
    isDisabled(planId, interval) {
      if (this.currentSubscription) {
        if (this.currentSubscription.renewal_plan) {
          return (
            this.currentSubscription.renewal_plan.plan == planId &&
            this.currentSubscription.renewal_plan.interval == interval
          );
        } else {
          return (
            this.currentSubscription.plan.id == planId &&
            this.currentSubscription.interval == interval
          );
        }
      }
      return false;
    },
    getPlans() {
      axios.get("/subscriptions/plans").then((response) => {
        this.$store.commit("setPlans", response.data);
      });
    },
  },
};
</script>
